const features = [
  {
    icon: 'ri-database-2-line',
    title: 'Smart Data Organization',
    description: 'Automatically categorize and structure your orders with intelligent templates that adapt to your purchasing patterns. No more manual data entry or scattered spreadsheets across different platforms.',
    image: 'https://readdy.ai/api/search-image?query=Modern%20minimalist%20desk%20setup%20with%20neatly%20organized%20color-coded%20folders%20and%20data%20cards%20spread%20across%20a%20clean%20white%20surface%2C%20soft%20natural%20light%20from%20large%20window%2C%20organized%20filing%20system%20aesthetic%2C%20warm%20beige%20and%20soft%20coral%20accents%2C%20editorial%20organization%20photography%2C%20clean%20balanced%20composition%20with%20shallow%20depth%20of%20field&width=600&height=400&seq=why-choose-data-v2&orientation=landscape',
  },
  {
    icon: 'ri-flow-chart',
    title: 'Advanced Spreadsheet Workflow',
    description: 'Streamline your entire procurement process from product discovery to final delivery with automated status updates, conditional formatting, and integrated calculation formulas.',
    image: 'https://readdy.ai/api/search-image?query=Sleek%20modern%20workspace%20with%20large%20monitor%20showing%20complex%20workflow%20diagram%20and%20process%20automation%20charts%2C%20coffee%20cup%20on%20desk%2C%20warm%20afternoon%20sunlight%2C%20clean%20white%20and%20sage%20green%20aesthetic%2C%20professional%20yet%20creative%20atmosphere%2C%20editorial%20tech%20workspace%20photography%2C%20soft%20shadows%20and%20bright%20highlights&width=600&height=400&seq=why-choose-workflow-v2&orientation=landscape',
  },
  {
    icon: 'ri-line-chart-line',
    title: 'Business Research Management',
    description: 'Track competitor pricing, analyze market trends, and make data-driven sourcing decisions with built-in analytics tools designed for e-commerce entrepreneurs.',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20business%20analytics%20scene%20with%20iPad%20displaying%20market%20trend%20graphs%20and%20colorful%20bar%20charts%2C%20fresh%20flowers%20in%20glass%20vase%20on%20white%20marble%20desk%2C%20soft%20diffused%20daylight%2C%20sophisticated%20modern%20office%20aesthetic%2C%20warm%20peach%20and%20cream%20tones%2C%20editorial%20business%20photography%2C%20clean%20minimal%20composition&width=600&height=400&seq=why-choose-research-v2&orientation=landscape',
  },
  {
    icon: 'ri-radar-line',
    title: 'Easy Information Tracking',
    description: 'Monitor every order in real-time with a unified dashboard that displays shipping status, warehouse location, quality check results, and estimated delivery dates at a glance.',
    image: 'https://readdy.ai/api/search-image?query=Clean%20desk%20with%20tablet%20showing%20package%20tracking%20map%20with%20delivery%20route%20pins%20and%20status%20updates%2C%20small%20cardboard%20shipping%20boxes%20nearby%2C%20warm%20natural%20light%20through%20blinds%2C%20organized%20productive%20atmosphere%2C%20soft%20sage%20green%20and%20warm%20beige%20color%20palette%2C%20editorial%20logistics%20photography%2C%20bright%20airy%20feel&width=600&height=400&seq=why-choose-tracking-v2&orientation=landscape',
  },
];

export default function WhyChooseSection() {
  return (
    <section id="why-choose" className="py-16 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-12">
          <span className="inline-block text-xs font-semibold tracking-wider uppercase text-secondary-700 bg-secondary-100 px-3 py-1 rounded-full mb-4">
            Why Basetao Spreadsheet
          </span>
          <h2 className="font-heading text-2xl md:text-4xl font-bold text-foreground-950 mb-3">
            Why Choose Basetao Spreadsheet?
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            Designed specifically for Basetao users, the spreadsheet offers capabilities that generic tools simply cannot match.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {features.map((feature) => (
            <div
              key={feature.title}
              className="group bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-accent-300/60 transition-all duration-300 cursor-default"
            >
              <div className="h-40 overflow-hidden">
                <img
                  src={feature.image}
                  alt={feature.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-5">
                <div className="w-10 h-10 rounded-lg bg-accent-100 flex items-center justify-center mb-3 group-hover:bg-accent-200 transition-colors">
                  <i className={`${feature.icon} w-5 h-5 flex items-center justify-center text-accent-700`}></i>
                </div>
                <h3 className="font-heading text-base font-semibold text-foreground-900 mb-2">{feature.title}</h3>
                <p className="text-sm text-foreground-600 leading-relaxed">{feature.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}